import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-add-characteristics-modal',
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    ReactiveFormsModule,
    MatIcon,
    CommonModule,
  ],
  templateUrl: './add-characteristics-modal.component.html',
  styleUrl: './add-characteristics-modal.component.css',
})
export class AddCharacteristicsModalComponent {
  readonly dialogRef = inject(MatDialogRef<AddCharacteristicsModalComponent>);
  readonly data = inject<any>(MAT_DIALOG_DATA);

  characteristicsForm: FormGroup;
  values: string[] = ['Low', 'Mild', 'High'];

  constructor(private fb: FormBuilder) {
    if (this.data.characteristic) {
      this.characteristicsForm = this.fb.group({
        newCharacteristics: [
          this.data.characteristic.name,
          [Validators.required, Validators.minLength(3), Validators.maxLength(20)],
        ],
        value: [
          this.data.characteristic.value,
          [Validators.required, Validators.minLength(3), Validators.maxLength(20)],
        ],
      });
    } else {
      this.characteristicsForm = this.fb.group({
        newCharacteristics: [
          '',
          [Validators.required, Validators.minLength(3), Validators.maxLength(20)],
        ],
        value: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(20)]],
      });
    }
  }

  ngOnInit(): void {}

  get newCharacteristics() {
    return this.characteristicsForm.get('newCharacteristics');
  }

  get value() {
    return this.characteristicsForm.get('value');
  }

  onSubmit(): void {
    if (this.characteristicsForm.valid) {
      console.log('Form Submitted:', this.characteristicsForm.value);
    } else {
      console.log('Form is invalid');
    }
  }

  addCharacteristics() {
    this.dialogRef.close({
      name: this.characteristicsForm.get('newCharacteristics')?.value,
      value: this.characteristicsForm.get('value')?.value,
    });
  }
}
